// @create-index
export { default as man } from './man.js';
export { default as profile } from './profile.js';
export { default as woman } from './woman.js';
//# sourceMappingURL=index.js.map